export { default as ExchangeRatesList } from './ExchangeRatesList';
